export type KelompokSlot = "Beranda dan paket" | "Halaman sistem" | "Dialog" | "Halaman" | "Keadaan kosong"

export type KunciGambarBawaan = "hero-beranda" | "proses-instan"

export type KunciSlot =
  | KunciGambarBawaan
  | "sistem-401"
  | "sistem-403"
  | "sistem-404"
  | "sistem-429"
  | "sistem-500"
  | "sistem-pemeliharaan"
  | "sistem-offline"
  | "konfirmasi-email"
  | "trial-tidak-bisa-diperpanjang"
  | "garansi"
  | "keranjang-kedaluwarsa"
  | "riwayat-kosong"
  | "ulasan-kosong"
  | "transaksi-tidak-ditemukan"
  | "pencarian-global"

export interface DefinisiSlot {
  kunci: KunciSlot
  kelompok: KelompokSlot
  label: string
  dipakaiDi: string
  lebar: number
  tinggi: number
  gaya: string
  format: string[]
  maksKb: number
  animasi: boolean
  bawaanUrl?: string
}

export type KunciMaskot = Exclude<KunciSlot, KunciGambarBawaan>

const GAYA_ILUSTRASI = "Maskot yang sama di semua halaman supaya terasa satu keluarga: robot server kotak berwajah layar, antena kecil, warna utama situs. Satu adegan di tengah, latar transparan, sisakan ruang di tepi."

function adegan(isi: string): string {
  return `${isi} ${GAYA_ILUSTRASI}`
}

function halamanSistem(kunci: KunciSlot, label: string, dipakaiDi: string, isi: string): DefinisiSlot {
  return { kunci, kelompok: "Halaman sistem", label, dipakaiDi, lebar: 960, tinggi: 760, gaya: adegan(isi), format: ["PNG", "WebP", "SVG"], maksKb: 300, animasi: false }
}

function keadaanKosong(kunci: KunciSlot, label: string, dipakaiDi: string, isi: string): DefinisiSlot {
  return { kunci, kelompok: "Keadaan kosong", label, dipakaiDi, lebar: 720, tinggi: 570, gaya: adegan(isi), format: ["PNG", "WebP", "SVG"], maksKb: 250, animasi: false }
}

export const URL_HERO_BAWAAN = "https://cdn.zass.in/dYXsPRpYJl.png"
export const URL_PROSES_INSTAN_BAWAAN = "/aset/proses-instan.png"

export const DAFTAR_SLOT: DefinisiSlot[] = [
  {
    kunci: "hero-beranda",
    kelompok: "Beranda dan paket",
    label: "Hero beranda",
    dipakaiDi: "Gambar di sisi kanan bagian hero halaman utama",
    lebar: 1000,
    tinggi: 1000,
    gaya: "Maskot atau ilustrasi utama merek, latar transparan, objek di tengah dengan ruang di tepi. Tampil besar di atas lipatan layar, jadi pakai gambar tajam.",
    format: ["PNG", "WebP", "SVG"],
    maksKb: 400,
    animasi: false,
    bawaanUrl: URL_HERO_BAWAAN,
  },
  {
    kunci: "proses-instan",
    kelompok: "Beranda dan paket",
    label: "Proses instan",
    dipakaiDi: "Ikon di sisi kanan setiap kartu paket di halaman /plans",
    lebar: 224,
    tinggi: 224,
    gaya: "Ikon atau ilustrasi kecil bertema kecepatan atau aktivasi instan, latar transparan. Tampil sekitar 112 px dan berubah abu-abu saat paket tidak tersedia.",
    format: ["PNG", "WebP", "SVG"],
    maksKb: 80,
    animasi: false,
    bawaanUrl: URL_PROSES_INSTAN_BAWAAN,
  },
  halamanSistem("sistem-401", "401 · Perlu masuk", "Halaman yang butuh login", "Adegan: maskot memegang kunci di depan gembok besar yang tertutup."),
  halamanSistem("sistem-403", "403 · Akses ditolak", "Halaman yang tidak boleh dibuka akun ini", "Adegan: maskot berwajah tegas mengangkat tangan seperti 'stop' di samping rambu dilarang."),
  halamanSistem("sistem-404", "404 · Tidak ditemukan", "Alamat yang tidak ada", "Adegan: maskot bingung mengintip lewat kaca pembesar, tanda tanya melayang di sekitarnya."),
  halamanSistem("sistem-429", "429 · Terlalu banyak permintaan", "Saat pembatas laju aktif", "Adegan: maskot berkeringat memegang stopwatch besar, panik tapi lucu."),
  halamanSistem("sistem-500", "500 · Gangguan server", "Saat terjadi galat tak terduga", "Adegan: maskot terjatuh dan terbaring miring, mata silang, bintang pusing dan percikan di atas kepalanya."),
  halamanSistem("sistem-pemeliharaan", "Pemeliharaan", "Saat mode pemeliharaan aktif", "Adegan: maskot memakai helm proyek dan memegang kunci inggris di dekat roda gigi."),
  halamanSistem("sistem-offline", "Offline", "Saat perangkat tidak punya koneksi", "Adegan: maskot lesu memegang colokan yang terlepas, awan dicoret di belakangnya."),
  { kunci: "konfirmasi-email", kelompok: "Dialog", label: "Konfirmasi email", dipakaiDi: "Dialog 'Apakah emailmu sudah benar?' di keranjang", lebar: 640, tinggi: 400, gaya: adegan("Adegan: maskot senang membawa amplop dengan notifikasi merah. Rasio 16:10, boleh GIF pendek."), format: ["PNG", "WebP", "GIF"], maksKb: 500, animasi: true },
  { kunci: "trial-tidak-bisa-diperpanjang", kelompok: "Dialog", label: "Server trial tak bisa diperpanjang", dipakaiDi: "Lembar info di riwayat transaksi trial cloud", lebar: 480, tinggi: 380, gaya: adegan("Adegan: maskot cemas memegang jam pasir bertanda silang merah."), format: ["PNG", "WebP", "SVG"], maksKb: 150, animasi: false },
  { kunci: "garansi", kelompok: "Halaman", label: "Halaman garansi", dipakaiDi: "Bagian atas halaman klaim garansi", lebar: 720, tinggi: 570, gaya: adegan("Adegan: maskot ceria membawa perisai bercentang hijau, bintang kecil di sekitarnya."), format: ["PNG", "WebP", "SVG"], maksKb: 300, animasi: false },
  keadaanKosong("keranjang-kedaluwarsa", "Keranjang kedaluwarsa", "Halaman keranjang saat sesinya habis atau sudah dipakai", "Adegan: maskot mengangkat bahu di samping keranjang kosong dan jam dinding."),
  keadaanKosong("riwayat-kosong", "Riwayat kosong", "Riwayat transaksi pengguna yang belum punya data", "Adegan: maskot melongok ke dalam kardus kosong."),
  keadaanKosong("ulasan-kosong", "Belum ada ulasan", "Halaman ulasan publik yang belum punya ulasan", "Adegan: maskot menulis dengan pena di samping bintang-bintang kosong bergaris putus."),
  keadaanKosong("transaksi-tidak-ditemukan", "Transaksi tidak ditemukan", "Detail riwayat dengan ID yang tidak cocok dan hasil pencarian yang kosong", "Adegan: maskot mencari lewat kaca pembesar di dekat tumpukan struk."),
  keadaanKosong("pencarian-global", "Pencarian global", "Tab Global di riwayat transaksi sebelum pengguna mengetik", "Adegan: maskot tersenyum membawa kaca pembesar, siap mencari."),
]

const PETA = new Map<string, DefinisiSlot>(DAFTAR_SLOT.map((slot) => [slot.kunci, slot]))

export function cariSlot(kunci: string): DefinisiSlot | null {
  return PETA.get(kunci) ?? null
}

export function adalahSlotMaskot(kunci: KunciSlot): kunci is KunciMaskot {
  return !cariSlot(kunci)?.bawaanUrl
}

export function rasioSlot(slot: Pick<DefinisiSlot, "lebar" | "tinggi">): number {
  return slot.lebar / slot.tinggi
}

export function kelompokkanSlot(): Array<{ kelompok: KelompokSlot; slot: DefinisiSlot[] }> {
  const urutan: KelompokSlot[] = ["Beranda dan paket", "Halaman sistem", "Dialog", "Halaman", "Keadaan kosong"]
  return urutan.map((kelompok) => ({ kelompok, slot: DAFTAR_SLOT.filter((item) => item.kelompok === kelompok) }))
}
